export interface CalendarEventInput {
  brideName: string;
  groomName: string;
  weddingDate: string | Date;
  location?: string;
  details?: string;
  durationHours?: number;
}

const formatIcsDate = (date: Date) => date.toISOString().replace(/-|:|\.\d+/g, '');

export function buildGoogleCalendarUrl(input: CalendarEventInput): string {
  const start = input.weddingDate instanceof Date ? input.weddingDate : new Date(input.weddingDate);
  const durationMs = (input.durationHours ?? 6) * 60 * 60 * 1000;
  const end = new Date(start.getTime() + durationMs);

  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: `Boda de ${input.brideName} & ${input.groomName}`,
    dates: `${formatIcsDate(start)}/${formatIcsDate(end)}`,
    location: input.location ?? '',
    details: input.details ?? '¡Los esperamos!',
  });

  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}
